import React from 'react'
import Color from "../Colors/Color"
import { Link, animateScroll as scroll } from "react-scroll";
import "./Footer.css"
import { useNavigate } from 'react-router-dom';

const Footer = () => {

  const navigate = useNavigate();

  const changePage = (pages) => {
        
    switch(pages){
        case "home": {
            navigate("/");
            break;
        }
        case "products": {
            navigate("/products");
            break;
        }
        case "services": {
            navigate("/services");
            break;
        }
        default:{
            navigate("/");
            break;
        }
    }
}

// const handleLocationClick = () => {
//   // Replace with your specific latitude and longitude
//   const latitude = 9.03246;
//   const longitude = 38.76909;
  
//   // Construct the Google Maps URL
//   const googleMapsUrl = `https://www.google.com/maps?q=${latitude},${longitude}`;

//   // Redirect the user to Google Maps
//   window.location.href = googleMapsUrl;
// };

const handleLocationClick = () => {
  // Replace with the registered place name
  const placeId = 'ChIJB_QK1duFSxYRqwJpz3SfCwA';

  // Construct the Google Maps URL using the place name
  const googleMapsUrl = `https://www.google.com/maps/place/?q=place_id:${placeId}`;

  // Redirect the user to Google Maps
  window.location.href = googleMapsUrl;
};


  return (
    <div className='footer-container' style={{backgroundColor:Color.primaryBackground, color: Color.secondaryText}} id='footer'>
      <div className='footer-logo-container'>
        <img src='/Images/logo.png' alt='opc-logo' className='footer-logo' />
      </div>
      <div className='footer-content-container'>
        <ul className='footer-link-list'>
          <li className='footer-link-item'>
            LINKS
          </li>
          <li className='footer-link-item'>
            <Link
                activeClass="navbar-link active"
                className="navbar-link"
                to="navbar"
                spy={true}
                smooth={true}
                offset={-100}
                duration={150}
                onClick={() => changePage('home')}
                style={{color: Color.secondaryText}}
            >
                Home
            </Link>
          </li>
          <li className='footer-link-item'>
          <Link
                activeClass="navbar-link active"
                className="navbar-link"
                to="navbar"
                spy={true}
                smooth={true}
                offset={-120}
                duration={150}
                onClick={() => changePage('services')}
                style={{color: Color.secondaryText}}
            >
                Services
            </Link>
          </li>
          <li className='footer-link-item'>
          <Link
                activeClass="navbar-link active"
                className="navbar-link"
                to="navbar"
                spy={true}
                smooth={true}
                offset={-120}
                duration={150}
                onClick={() => changePage('products')}
                style={{color: Color.secondaryText}}
            >
                Products
            </Link>
          </li>
        </ul>

        <ul className='footer-connect-list'>
          <li className='footer-connect-item'>
            CONNECT
          </li>
          <li className='footer-connect-item'>
            <a href="mailto:abiy1967@gmail.com" className="footer-email"> {/*<span className="fa-solid fa-envelope footer-envelope-icon"></span>*/} <h6>abiy1967@gmail.com</h6></a>
          </li>
          <li className='footer-connect-item'>
            <a href="tel:+251992787878" className="footer-phone"> {/*<span className="fa-solid fa-phone footer-phone-icon"></span>*/} <h6>+251992787878 / <a href="tel:+251946668797" className="footer-phone"> <span className='footer-phone-2nd'>+251946668797</span> </a></h6></a>
          </li>
          <li className='footer-connect-item small-size'>
            <a href="tel:+251946668797" className="footer-phone"> <h6>+251946668797</h6></a>
          </li>
        </ul>

        <ul className='footer-location-list' onClick={handleLocationClick}>
          <li className='footer-location-item'>
            LOCATION
          </li>
          <li className='footer-location-item'>
            4 Kilo around St.Matthews Anglican Church,
          </li>
          <li className='footer-location-item'>
            Next to DICAC/RRAD Head Office
          </li>
        </ul>
      </div>
    </div>
  )
}

export default Footer